import '@/common/components/icons/material-symbols.css'
import { mds } from '@/common/components/icons/materialSymbols'
import { ncIconSet } from '@/common/components/icons/nc'
import { nocalAliases } from '@/common/components/icons/nocalMdsAliases'
import '@mdi/font/css/materialdesignicons.min.css'
import { type App, watch } from 'vue'
import { createVuetify } from 'vuetify'
import { mdi } from 'vuetify/iconsets/mdi'
import { de, en, es, fr, ja, ko, pt, ru, zhHans, zhHant } from 'vuetify/locale'
import 'vuetify/styles'
import { useTheme } from '../composables/useTheme'
import { themeLibrary } from './theme'

const vuetify = createVuetify({
  defaults: {
    VSwitch: {
      color: 'white'
    },
    VBtn: {
      variant: 'tonal'
    }
  },
  display: {
    mobileBreakpoint: 'lg',
    thresholds: {
      xs: 0,
      sm: 360,
      md: 400,
      lg: 540, // Big phone
      xl: 960,
      xxl: 1280
    }
  },
  locale: {
    messages: { ko, en, zhHans, zhHant, de, es, ja, fr, ru, pt },
    locale: 'en',
    fallback: 'en'
  },
  icons: {
    defaultSet: 'mds',
    aliases: nocalAliases,
    sets: {
      mds,
      mdi,
      nc: ncIconSet
    }
  },
  theme: {
    defaultTheme: 'shadow',
    themes: themeLibrary.reduce((acc, theme) => {
      acc[theme.id] = theme.theme
      return acc
    }, {} as any)
  }
})

export default function (app: App, options?: { alwaysFollowSystem?: boolean }) {
  app.use(vuetify)

  const { activeTheme } = useTheme(options)

  if (typeof window !== 'undefined') {
    watch(
      activeTheme,
      (newActiveTheme) => {
        if (newActiveTheme) {
          vuetify.theme.change(newActiveTheme.id)
        }
      },
      { immediate: true }
    )
  }
}
